import React from 'react'
import cn from 'classnames'
import Router from 'next/router'

import { Pagination } from '@components/Pagination'
import { CommentType } from '@models/comment/CommentType'
import { diffNow } from '@lib/utils'
import { ThemeEnum } from '@hooks/contexts/ThemeContext/interface'
import { CommentProps } from './interface'
import { CommentReply } from './components/CommentReply'
import CommentBox from './components/CommentBox'

export function Comment({
  comments,
  onMainCommentSubmit,
  replyComment,
  likeComment,
  manageComment,
  replyUser,
  className,
  page,
  perpage,
  handlePaginationChange,
  total,
  user,
  unHiddenComment,
  onReplyCommentSubmit,
  editCommentId,
  onCancelEditComment,
  onEditCommentSubmit,
  authorUserId,
  isHiddenInput = false,
  commentCount,
  lastCommentDate,
  isCommentAble,
  isUserHasBlockedComment,
  isDrawer,
  visibleSubComment,
  theme,
}: CommentProps) {
  const isLightOrSepiaTheme = [ThemeEnum.LIGHT, ThemeEnum.SEPIA].includes(theme)
  const isLightTheme = ThemeEnum.LIGHT === theme
  const isSepiaTheme = ThemeEnum.SEPIA === theme
  const isNightOrDarkTheme = [ThemeEnum.NIGHT, ThemeEnum.DARK].includes(theme)
  const isDarkTheme = theme === ThemeEnum.DARK

  return (
    <>
      <div
        id='comment'
        className={cn(
          'card w-full p-[30px] mobile:p-[20px] tablet-mobile:rounded-none dark:bg-dark dark:border-dark shadow-card border',
          className,
          {
            'bg-white border-gray-4': isLightTheme,
            'bg-sepia border-sepia-1': isSepiaTheme,
            'mobile:mb-[100px]': isDrawer,
            '!dark-mode !border-dark-5 !bg-dark-5':
              isDarkTheme &&
              Router.pathname === '/story/[id]/chapter/[chapterId]',
          }
        )}
      >
        <div
          className={cn(
            'border-b-[1px] desktop-tablet:pb-[10px] desktop-tablet:mb-[10px]',
            {
              'border-gray-3': isLightOrSepiaTheme,
              '!border-white/10':
                isNightOrDarkTheme &&
                Router.pathname === '/story/[id]/chapter/[chapterId]',
            }
          )}
        >
          <div
            className={cn(
              'text-[24px] dark:text-dark-10 font-mitr font-medium',
              {
                'text-secondary': isLightOrSepiaTheme,
                '!text-gray-16':
                  isDarkTheme &&
                  Router.pathname === '/story/[id]/chapter/[chapterId]',
              }
            )}
          >
            ความคิดเห็น
          </div>
          <div
            className={cn(
              'text-[14px] dark:text-dark-10 font-sarabun font-light pt-[10px]',
              {
                'text-secondary-1': isLightOrSepiaTheme,
                '!text-gray-16':
                  isDarkTheme &&
                  Router.pathname === '/story/[id]/chapter/[chapterId]',
              }
            )}
          >
            <span
              className={cn('dark:text-secondary-1', {
                'text-secondary': isLightOrSepiaTheme,
                '!text-gray-16':
                  isDarkTheme &&
                  Router.pathname === '/story/[id]/chapter/[chapterId]',
              })}
            >
              {commentCount.toLocaleString()} ความคิดเห็น
              {lastCommentDate ? ',' : ''}
            </span>
            {lastCommentDate
              ? ` อัปเดตล่าสุด ${diffNow(lastCommentDate, 'ที่แล้ว')}`
              : ''}
          </div>
          {user?.isBan ? (
            <div className='text-center text-secondary-1 text-sm font-light py-[30px] rounded-[20px] bg-gray-4 mt-[20px] mb-[10px]'>
              คุณถูกแบนการแสดงความคิดเห็นโดยแอดมิน
            </div>
          ) : !isHiddenInput && isCommentAble ? (
            <>
              {isUserHasBlockedComment ? (
                <div className='text-center text-secondary-1 text-sm font-light py-[30px] rounded-[20px] bg-gray-4 mt-[20px] mb-[10px]'>
                  คุณถูกบล็อกการแสดงความคิดเห็นโดยเจ้าของเรื่อง
                </div>
              ) : (
                <CommentBox
                  className='pb-[20px]'
                  mode='create'
                  onSubmit={onMainCommentSubmit}
                  user={user}
                />
              )}
            </>
          ) : (
            <div className='text-center text-secondary-1 text-sm font-light py-[30px] rounded-[20px] bg-gray-4 mt-[20px] mb-[10px]'>
              ความคิดเห็นเรื่องนี้ถูกปิดโดยเจ้าของเรื่อง
            </div>
          )}
        </div>
        <div className='mb-[30px]'>
          <div className='w-full' />
          {comments?.map((comment: CommentType) => (
            <CommentReply
              key={comment.id}
              comment={comment}
              replyComment={replyComment}
              likeComment={likeComment}
              manageComment={manageComment}
              unHiddenComment={unHiddenComment}
              replyUser={replyUser}
              onReplyCommentSubmit={onReplyCommentSubmit}
              user={user}
              editCommentId={editCommentId}
              onCancelEditComment={onCancelEditComment}
              onEditCommentSubmit={onEditCommentSubmit}
              authorUserId={authorUserId}
              isCommentAble={isCommentAble}
              isUserHasBlockedComment={isUserHasBlockedComment}
              isDrawer={isDrawer}
              visibleSubComment={visibleSubComment}
            />
          ))}
        </div>
        {comments.length > 0 && (
          <Pagination
            page={page}
            perpage={perpage}
            total={total}
            pageChange={handlePaginationChange}
          />
        )}
      </div>
    </>
  )
}
